import { useMemo } from "react";

const labels = {
  English: {
    Dashboard: "Dashboard",
    ManageTrackResponse: "Manage and track your reference response",
    StartReferenceCheck: "Start Reference Check",
    ActiveJobs: "Active Jobs",
    PendingReferences: "Pending References",
    CompletedReferences: "Completed References",
    TotalApplicants: "Total Applicants",
    ReferenceOverview: "Reference Overview",
    ByDepartment: "By Department",
    RecentActivities: "Recent Activities",
    ClickToStart: "Click here to begin the reference check process.",
    ManageTrackProcesses: "Manage and track your reference check processes.",
    completed: "completed",
    NoRecentActivities: "No recent activities",
    ViewAll: "View All",
    ShowLess: "Show Less",
    departments: {
      sales: "Sales",
      marketing: "Marketing",
      customerService: "Customer Service",
      hr: "Human Resources (HR)",
      finance: "Finance",
      accounting: "Accounting",
      operations: "Operations",
      it: "IT (Information Technology)",
      legal: "Legal",
      administration: "Administration",
      productDevelopment: "Product Development",
      rAndD: "Research and Development (R&D)",
      logistics: "Logistics, Supply Chain & Procurement",
      businessDev: "Business Development",
      pr: "Public Relations (PR)",
      design: "Design",
      compliance: "Compliance",
      riskManagement: "Risk Management",
    },
    Total: "Total",
    Complete: "Complete",
    months: {
      January: "January",
      February: "February",
      March: "March",
      April: "April",
      May: "May",
      June: "June",
      July: "July",
      August: "August",
      September: "September",
      October: "October",
      November: "November",
      December: "December",
    },
    "a reference check for": "a reference check for",
    ago: "ago",
    TotalCredits: "Total Credits",
    AddCredits: "Add Credits",
    TotalRate: "Total Rate",
    AcceptanceRate: "Acceptance Rate",
    createNewJob: "Create New",
    job: "Job and Applicant",
    addNewJob:
      "Add a new job opening and applicant to the system. Fill out the details below.",
    referredBy: "Referred By",
    jobDetails: "Job Details",
    fillRequired: "* Fill in the required information",
    jobName: "Job Name",
    vacancy: "Vacancies",
    department: "Department",
    hiringManager: "Hiring Manager",
    firstName: "First Name",
    lastName: "Last Name",
    applicantDetails: "Applicant Details",
    referenceFormat: "Reference Format",
    applicant: "Applicant",
    email: "Email",
    cancel: "Cancel",
    proceed: "Proceed",
    selectDepartment: "Select Department",
    numReferees: "No. of Referees",
    backWarning:
      "Are you sure you want to go back? Your progress will be lost.",
    noCustomQuestions: "No custom questions available",
    hrHatch: "Snappcheck",
    custom: "Custom Questionnaire",
    standardFormat: "Standard Format",
    managementFormat: "Management Format",
    executiveFormat: "Executive Format",
    placeholders: {
      jobName: "Enter job title",
      firstName: "Enter first name",
      lastName: "Enter last name",
      email: "Enter email address",
      selectDepartment: "Select department",
      referredBy: "Select referee",
      vacancy: "Enter number of vacancies",
      referees: "Enter number of referees",
    },
    selectAgency: "Select Agency",
    noAgencyRecord: "No agency records found",
  },
  Japanese: {
    Dashboard: "ダッシュボード",
    ManageTrackResponse: "リファレンスチェックの管理と追跡",
    StartReferenceCheck: "リファレンスチェックを開始する",
    ActiveJobs: "求人",
    PendingReferences: "保留中のリファレンス",
    CompletedReferences: "完了リファレンス",
    TotalApplicants: "応募者数",
    ReferenceOverview: "リファレンスチェック概要",
    ByDepartment: "部門別",
    RecentActivities: "最近の活動",
    ClickToStart:
      "ここをクリックしてリファレンスチェックプロセスを開始します。",
    ManageTrackProcesses: "リファレンスチェックプロセスを管理し、追跡します。",
    completed: "完了",
    NoRecentActivities: "最近の活動はありません",
    ViewAll: "すべて表示",
    ShowLess: "表示を減らす",
    departments: {
      sales: "営業",
      marketing: "マーケティング",
      customerService: "カスタマーサービス",
      hr: "人事",
      finance: "財務",
      accounting: "経理",
      operations: "運営",
      it: "IT",
      legal: "法務",
      administration: "総務",
      productDevelopment: "製品開発",
      rAndD: "研究開発",
      logistics: "物流・調達",
      businessDev: "事業開発",
      pr: "広報",
      design: "デザイン",
      compliance: "コンプライアンス",
      riskManagement: "リスク管理",
    },
    Total: "合計",
    Complete: "完了",
    months: {
      January: "1月",
      February: "2月",
      March: "3月",
      April: "4月",
      May: "5月",
      June: "6月",
      July: "7月",
      August: "8月",
      September: "9月",
      October: "10月",
      November: "11月",
      December: "12月",
    },
    "a reference check for": "のリファレンスチェック",
    ago: "前",
    TotalCredits: "総クレジット",
    AddCredits: "クレジットを追加",
    TotalRate: "総レート",
    AcceptanceRate: "承認率",
    createNewJob: "新規作成",
    job: "ジョブと応募者",
    addNewJob:
      "システムに新しい求人と応募者を追加します。以下の詳細を入力してください。",
    referredBy: "紹介者",
    jobDetails: "職務内容",
    fillRequired: "* 必須情報を入力してください",
    jobName: "職種名",
    vacancy: "空き",
    department: "部署",
    hiringManager: "採用担当者",
    firstName: "名",
    lastName: "姓",
    applicantDetails: "応募者詳細",
    referenceFormat: "リファレンス形式",
    applicant: "応募者",
    email: "メールアドレス",
    cancel: "キャンセル",
    proceed: "続行",
    selectDepartment: "部署を選択",
    numReferees: "推薦者数",
    backWarning: "前のページに戻りますか？入力内容は失われます。",
    noCustomQuestions: "カスタム質問はありません",
    hrHatch: "HRハッチ",
    custom: "カスタムアンケート",
    standardFormat: "標準フォーマット",
    managementFormat: "管理職フォーマット",
    executiveFormat: "エグゼクティブフォーマット",
    placeholders: {
      jobName: "職種名を入力",
      firstName: "名を入力",
      lastName: "姓を入力",
      email: "メールアドレスを入力",
      selectDepartment: "部署を選択",
      referredBy: "紹介者を選択",
      vacancy: "募集人数を入力",
      referees: "推薦者数を入力",
    },
    selectAgency: "代理店を選択",
    noAgencyRecord: "代理店の記録が見つかりません",
  },
};

export const useLabels = (language = "English") => {
  const currentLabels = useMemo(() => {
    return labels[language] || labels.English;
  }, [language]);

  return {
    labels: currentLabels,
  };
};
